export default {
  meta: {
    title: '筹建项目管理',
  },
};
